import { useState } from "react";
import Grid from "@mui/material/Grid2";
import { Button, Grid2, useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import "./Auth.css";
import { CountryDropdown } from "react-country-region-selector";
import { Link, useNavigate } from "react-router-dom";
import Footer from "../Footer/Footer";
import Header from "../Header/MegaMenu";
import { ToastContainer, toast } from "react-toastify";
// import { createContactRequest } from "../../services/contactRequest";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import contactus from "../../assets/Images/contact-us-img.webp";
import EmailIcon from "@mui/icons-material/Email";
import discoverright from "../../assets/Images/discover-right-img.webp";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { Card, CardContent, Typography } from "@mui/material";
import { useSelector } from "react-redux";
const ContactUs = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const [country, setCountry] = useState("Select the Country");

  const navigate = useNavigate();

  const [contactRequest, setContactRequest] = useState({
    firstname: "",
    lastname: "",
    email: "",
    country: "",
    message: "",
    phonenumber: "",
    countryCode: "US",
  });

  const [errors, setErrors] = useState({
    firstname: "",
    lastname: "",
    email: "",
    country: "",
    message: "",
    countryCode: "US",
    phonenumber: "",
  });

  const [requestLoading, setRequestLoading] = useState(false);
  const handleChange = async (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
    setContactRequest({ ...contactRequest, [name]: value });
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;

    let errorMessage = "";
    if (fieldName === "email") {
      if (value === "" || value === undefined) {
      } else if (!/\S+@\S+\.\S+/.test(fieldValue)) {
        errorMessage = "Email is invalid";
        isValid = false;
      }
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;
    const specialCharAndNumberRegex = /[^a-zA-Z ]/;

    if (!contactRequest.firstname) {
      formErrors.firstname = "First Name is required";
      isValid = false;
    } else if (contactRequest.firstname?.length < 4) {
      formErrors.firstname = "First Name must be at least 4 characters long";
      isValid = false;
    } else if (specialCharAndNumberRegex.test(contactRequest.firstname)) {
      formErrors.firstname = "First Name should not contain special characters";
      isValid = false;
    }

    if (!contactRequest.lastname) {
      formErrors.lastname = "Last Name is required";
      isValid = false;
    } else if (contactRequest.lastname?.length < 4) {
      formErrors.lastname = "First Name must be at least 4 characters long";
      isValid = false;
    } else if (specialCharAndNumberRegex.test(contactRequest.lastname)) {
      formErrors.lastname = "Last Name should not contain special characters";
      isValid = false;
    }

    if (!contactRequest.email) {
      formErrors.email = "Email is required";
      isValid = false;
    }
    if (!country || country === "Select the Country") {
      formErrors.country = "Country is required";
      isValid = false;
    }

    if (!contactRequest.message) {
      formErrors.message = "Message is required";
      isValid = false;
    }

    if (!contactRequest.phonenumber) {
      formErrors.phonenumber = "Phone Number is required";
      isValid = false;
    }
    if (contactRequest?.phonenumber?.length < 3) {
      formErrors.phonenumber = "Phone Number is not valid";
      isValid = false;
    }
    // else if(contactRequest.message?.length<5){
    //   formErrors.firstname="Message must be at least 5 characters long";
    //   isValid = false;
    // }

    setErrors(formErrors);
    return isValid;
  };

  const handleKeyPress = (e) => {
    const regex = /[^a-zA-Z ]/;
    const key = e.key;
    if (regex.test(key)) {
      e.preventDefault();
    }
    const inputLength = e.target.value.length;
    if (inputLength >= 40) {
      e.preventDefault();
    }
  };

  const handlePhoneChange = (value, country, e, formattedValue) => {
    // Only update the phone number if the entered value starts with the country code
    if (value.startsWith(country.dialCode)) {
      setContactRequest({
        ...contactRequest,
        phonenumber: `+${value}`,
        countryCode: country?.iso2?.toUpperCase(),
      });
      setErrors((prevErrors) => ({
        ...prevErrors,
        phonenumber: "",
      }));
    }
  };

  const handleSubmit = async () => {
    if (validate()) {
      setRequestLoading(true);

      const data = {
        firstname: contactRequest.firstname,
        lastname: contactRequest.lastname,
        email: contactRequest.email,
        country: country,
        message: contactRequest.message,
        phonenumber: contactRequest.phonenumber,
      };
      // const response = await createContactRequest(data);
      // if (response?.data?.success === true) {
      //   toast.success(response.data.message);

      //   setRequestLoading(false);
      //   setContactRequest({
      //     firstname: "",
      //     lastname: "",
      //     email: "",
      //     country: "",
      //     message: "",
      //   });

      //   setCountry("Select the Country");
      //   navigate("/success");
      // } else {
      //   toast.error(response?.data?.message);
      //   setRequestLoading(false);
      // }
    }
  };
  const [phone, setPhone] = useState("");
  return (
    <div className="auth-page">
      <Header />
      <Box
        component="form"
        className="contact-us"
        // sx={{ paddingTop: "80px" }}
        // sx={{ justifyContent: "center" }}
        // style={{ paddingTop: md ? "100px" : "60px " }}
      >
        <section className="form-grid">
          <div className="contain-width mb-20">
            <Grid
              container
              spacing={2}
              sx={{ alignItems: "center", justifyContent: "center" }}
              className="contactus-grid"
            >
              {/* {lg && (
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
              <div className="lgleft">
                <img src={contactus} alt="lgleft" />
              </div>
            </Grid>
          )} */}
              <Grid
                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                className="text-center mt-50"
              >
                <div className="heading">
                  <h2>
                    Get in
                    <span>Touch</span>
                  </h2>
                  <p>
                    Whether you have a question, feedback, or a project in mind, feel free to reach out. Our team is here to help and will get back to you as soon as possible.
                  </p>
                </div>
              </Grid>
              <Grid container className="form-container">
                <Grid
                  size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                  sx={{ display: !md ? "none" : "" }}
                  className="display-1"
                >
                  <div className="text-center">
                    <img width="90%" src={contactus} />
                  </div>
                </Grid>
                <Grid
                  item
                  size={{ xs: 12, sm: 12, md: 6, lg: 6, xl: 6 }}
                  sx={{
                    // display: "flex",
                    // justifyContent: "center",
                    // alignItems: "center",
                    maxWidth: "540px",
                    margin: "0 auto",
                  }}
                >
                  <Grid
                    container
                    style={{ display: "block" }}
                    sx={{
                      padding: "30px",
                      borderRadius: "10px",
                      background: "transparent",
                      boxShadow:
                        "0px 12px 16px 0px rgba(0, 0, 0, 0.04), 0px 4px 56px 0px rgba(0, 0, 0, 0.04)",
                    }}
                  >
                    <div
                      className={
                        !md ? "form-data mb-20 text-center" : "form-data mb-20"
                      }
                    >
                      <h3>Let's talk with us</h3>
                      <p>
                        Let's align our constellations! Reach out and let the magic of collaboration illuminate our skies.
                      </p>
                    </div>
                    <div className="display-3 flex-md-c">
                      <div className="input mb-20 form-error-tle mb-md-10">
                        {/* <InputLabel>First Name</InputLabel> */}
                        <TextField
                          placeholder="Last Name"
                          name="firstname"
                          onChange={(e) => handleChange(e)}
                          // onFocus={(e) => validateFocus(e)}
                          value={contactRequest.firstname}
                          type="text"
                          error={!!errors.firstname}
                          onKeyPress={handleKeyPress}
                          // onInput={validateFocus}
                          helperText={errors.firstname}
                          inputProps={{ maxLength: 40 }}
                        />
                      </div>

                      <div className="input mb-20 form-error-tle">
                        {/* <InputLabel>Last Name</InputLabel> */}
                        {/* <TextField placeholder="Last Name" /> */}
                        <TextField
                          placeholder="First Name"
                          name="lastname"
                          onChange={(e) => handleChange(e)}
                          value={contactRequest.lastname}
                          type="text"
                          error={!!errors.lastname}
                          onKeyPress={handleKeyPress}
                          helperText={errors.lastname}
                          inputProps={{ maxLength: 40 }}
                        />
                      </div>
                    </div>

                    <div className="input mb-20 form-error-tle">
                      {/* <InputLabel>Email</InputLabel> */}
                      <TextField
                        placeholder="Email"
                        name="email"
                        onChange={(e) => handleChange(e)}
                        value={contactRequest.email}
                        type="email"
                        onFocus={(e) => validateFocus(e)}
                        onInput={validateFocus}
                        error={!!errors.email}
                        helperText={errors.email}
                      />
                    </div>
                    <div className="input mb-20 form-error-tle">
                      {/* <InputLabel>Country</InputLabel> */}
                      <CountryDropdown
                        className="country-dropdown"
                        value={country}
                        onChange={(val) => {
                          setCountry(val);
                          setErrors((prevErrors) => ({
                            ...prevErrors,
                            country: "",
                          }));
                        }}
                      />
                      {errors.country && (
                        <div
                          style={{
                            color: "#d32f2f",
                            fontSize: "12px",
                            margin: "3px 14px ",
                          }}
                        >
                          {errors.country}
                        </div>
                      )}
                    </div>

                    <div className="input mb-20 form-error-tle">
                      {/* <InputLabel>Phone Number</InputLabel> */}
                      {/* <MuiTelInput
                  value={phone}
                  onChange={handleChangePhone}
                  defaultCountry="US"
                /> */}
                      <PhoneInput
                        country={contactRequest?.countryCode?.toLowerCase()}
                        value={contactRequest.phonenumber}
                        // onChange={(phone) => setPhone(phone)}
                        onChange={handlePhoneChange}
                        inputStyle={{
                          width: "100%",
                          height: "56px",
                          fontSize: "16px",
                          borderRadius: "4px",
                          paddingLeft: "48px",
                        }}
                        containerStyle={{ width: "100%" }}
                        buttonStyle={{ borderRadius: "4px" }}
                        enableSearch
                        international
                        countryCodeEditable={false}
                      />
                      {errors.phonenumber && (
                        <div
                          style={{
                            color: "#d32f2f",
                            fontSize: "12px",
                            margin: "3px 14px ",
                          }}
                        >
                          {errors.phonenumber}
                        </div>
                      )}
                    </div>
                    <div className="input mb-20 form-error-tle">
                      {/* <InputLabel>Message</InputLabel> */}
                      <TextField
                        className="mt-10 mb-20"
                        id="outlined-multiline-static"
                        multiline
                        rows={4}
                        placeholder="Message"
                        name="message"
                        type="text"
                        onChange={(e) => handleChange(e)}
                        value={contactRequest.message}
                        error={!!errors.message}
                        helperText={errors.message}
                      />
                    </div>

                    {/* <Link
                to="/success"
                style={{ width: "-webkit-fill-available" }}
                className="bg-btn mt-20"
              > */}
                    <Button
                      style={{ width: "-webkit-fill-available" }}
                      className="bg-btn mt-20"
                      onClick={(e) => handleSubmit(e)}
                      disabled={requestLoading === true}
                    >
                      Submit
                    </Button>
                    {/* </Link> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
        </section>

         <section className="get-in-touch-section">
          <div className="contain-width ">
            <Grid
              container
              spacing={2}
              sx={{ alignItems: "flexStart", justifyContent: "center" }}
            >
              <Grid
                item
                size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
                className="mb-30 mt-50"
              >
                <div className="discover">
                  <h4>DISCOVER US</h4>
                  <p>
                    From bold ideas to meaningful impact, our journey is driven
                    by passion, creativity, and purpose. Explore our story, our
                    values, and the people behind the work — and discover how we
                    bring vision to life.
                  </p>
                </div>
                <div className="quick-connect">
                  <div style={{ marginBottom: "30px" }}>
                    <h4>Registered Address</h4>
                    <p>
                      Ground Floor, The Sotheby Building, Rodney Village, Rodney
                      Bay Gros-Islet, Saint Lucia.
                    </p>
                  </div>
                  <h4>Quick Contact</h4>
                  <div className="mb-15 mt-15">
                    <p className="display-1 mb-10">Phone : 
                      <Link to="tel:+97144475716" >
                      +971-44475716

                    </Link>
                    </p>
                     <p className="display-1 mb-10">Support : 
                     <a
                      href="mailto:support@finowizprime.com"
                    >
                      Support@finowizprime.com
                    </a>
                    </p>
                     <p className="display-1 mb-10">Technical : 
                     <a
                      href="mailto:technical@finowizprime.com"
                    >
                      Technical@finowizprime.com

                    </a>
                    </p>
                     <p className="display-1 mb-10">Marketing : 
                      <a
                      href="mailto:marketing@finowizprime.com"
                    >
                      Marketing@finowizprime.com


                    </a>
                    </p>
                    {/* <Link to="tel:+97144475716" className="bg-btn display-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                      >
                        <path
                          d="M8 3.77344C8.5 3.77344 10.5 8.27344 10.5 8.77344C10.5 9.77344 9 10.7734 8.5 11.7734C8 12.7734 9 13.7734 10 14.7734C10.39 15.1634 12 16.7734 13 16.2734C14 15.7734 15 14.2734 16 14.2734C16.5 14.2734 21 16.2734 21 16.7734C21 18.7734 19.5 20.2734 18 20.7734C16.5 21.2734 15.5 21.2734 13.5 20.7734C11.5 20.2734 10 19.7734 7.5 17.2734C5 14.7734 4.5 13.2734 4 11.2734C3.5 9.27344 3.5 8.27344 4 6.77344C4.5 5.27344 6 3.77344 8 3.77344Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M14 7.8125C14.66 8.1225 15.26 8.5425 15.76 9.0525C16.25 9.5425 16.66 10.1325 16.96 10.7725"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-dasharray="4 4"
                        />
                        <path
                          d="M15 4.02344C16.41 4.39344 17.67 5.12344 18.67 6.12344C19.66 7.12344 20.39 8.37344 20.75 9.77344"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-dasharray="6 6"
                        />
                      </svg>
                      +971-44475716
                    </Link> */}
                    {/* <a
                      href="mailto:support@finowizprime.com"
                      className="border-btn display-1"
                    >
                      <EmailIcon />
                      support@finowizprime.com
                    </a> */}
                  </div>
                  <div style={{ margin: "30px 0" }}>
                    <h4>Physical Address</h4>
                    <p>
                      Office #1105, The Prism Tower, 139,Al Mustaqbal Street,
                      Business Bay, Dubai.
                    
                    </p>
                  </div>
                  {/* <h4>Business Hours</h4>
                  <p>Mon - Friday : 9 am to 5 pm, Satday : 10 am to 1 pm</p>
                  <Link to="" className="green-btn display-1 mt-15">
                    <WhatsAppIcon />
                    Whatsapp
                  </Link> */}
                </div>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}>
                <div className="text-right">
                  <img src={discoverright} alt="" />
                </div>
              </Grid>
            </Grid>
          </div>
        </section>

        <Card sx={{ width: "100%", background: "transparent" }}>
          <CardContent sx={{ p: 0 }}>
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
                width: "100%",
                paddingTop: "12.25%", // 16:9 Aspect Ratio
                mt: 2,
              }}
            >
              <iframe
                title="Dubai Location Map"
                src="https://maps.google.com/maps?q=Burj%20Khalifa&t=&z=15&ie=UTF8&iwloc=&output=embed"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                  filter: "grayscale(100%)", // black & white look
                }}
                allowFullScreen
                loading="lazy"
              />
            </Box>
          </CardContent>
        </Card>
      </Box>
      <Footer />
    </div>
  );
};

export default ContactUs;
